// 데이터 변환 및 유틸리티 함수들

// 안전한 toFixed 함수 - null/undefined 값을 처리
export const safeToFixed = (value: number | null | undefined, digits: number = 2): string => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0';
  }
  return value.toFixed(digits);
};

// URL 간략화 함수
export const truncateUrl = (url: string, maxLength: number = 80): string => {
  if (url.length <= maxLength) return url;
  return url.substring(0, maxLength) + '...';
};

// 중요한 성능 개선 기회 필터링 함수
export const getImportantOpportunities = (opportunities: any[]) => {
  if (!opportunities || !Array.isArray(opportunities)) {
    return [];
  }
  
  // 중요도가 높은 기회들을 필터링 (점수가 낮거나 절약 시간이 큰 것들)
  return opportunities
    .filter(opportunity => {
      // 점수가 낮거나(0.5 이하), 절약 시간이 1초 이상인 기회들
      return (opportunity.score !== null && opportunity.score <= 0.5) || 
             (opportunity.overallSavingsMs && opportunity.overallSavingsMs >= 1000);
    })
    .sort((a, b) => {
      // 절약 시간 기준으로 내림차순 정렬
      const savingsA = a.overallSavingsMs || 0;
      const savingsB = b.overallSavingsMs || 0;
      return savingsB - savingsA;
    });
};